// Class: openfl.display._internal.BitmapDataLoader

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;
var $import = require("./../../../import_stub").default;
function openfl_display_IDisplayObjectLoader() {return require("./../../../openfl/display/IDisplayObjectLoader");}
function openfl_display_BitmapData() {return require("./../../../openfl/display/BitmapData");}
function openfl_display_Bitmap() {return require("./../../../openfl/display/Bitmap");}
function lime_app_Future() {return require("./../../../lime/app/Future");}
function lime_app_Promise() {return require("./../../../lime/app/Promise");}
function openfl_net_URLLoader() {return require("./../../../openfl/net/URLLoader");}
function Std() {return require("./../../../Std");}

// Constructor

var BitmapDataLoader = function() {
}

// Meta

BitmapDataLoader.__name__ = "openfl.display._internal.BitmapDataLoader";
BitmapDataLoader.__isInterface__ = false;
BitmapDataLoader.__interfaces__ = [(openfl_display_IDisplayObjectLoader().default)];
BitmapDataLoader.prototype = {
	load: function(request,context,contentLoaderInfo) {
		var _gthis = this;
		if(contentLoaderInfo.contentType.indexOf("image/") > -1 && request.method == "GET" && (request.requestHeaders == null || request.requestHeaders.length == 0) && request.userAgent == null) {
			return (openfl_display_BitmapData().default).loadFromFile(request.url).then(function(bitmapData) {
				var content = new (openfl_display_Bitmap().default)(bitmapData);
				return (lime_app_Future().default).withValue(content);
			});
		}
		var promise = new (lime_app_Promise().default)();
		var loader = new (openfl_net_URLLoader().default)();
		loader.dataFormat = "binary";
		loader.addEventListener("complete",function(event) {
			var tmp = _gthis.loadBytes(loader.data,context,contentLoaderInfo);
			promise.completeWith(tmp);
		});
		loader.addEventListener("ioError",function(event1) {
			promise.error(event1);
		});
		loader.addEventListener("progress",function(event2) {
			var tmp1 = (Std().default).int(event2.bytesLoaded);
			var tmp2 = (Std().default).int(event2.bytesTotal);
			promise.progress(tmp1,tmp2);
		});
		loader.load(request);
		return promise.future;
	},
	loadBytes: function(buffer,context,contentLoaderInfo) {
		return (openfl_display_BitmapData().default).loadFromBytes(buffer).then(function(bitmapData) {
			var content = new (openfl_display_Bitmap().default)(bitmapData);
			return (lime_app_Future().default).withValue(content);
		});
	}
};
BitmapDataLoader.prototype.__class__ = BitmapDataLoader.prototype.constructor = $hxClasses["openfl.display._internal.BitmapDataLoader"] = BitmapDataLoader;

// Init



// Statics




// Export

exports.default = BitmapDataLoader;